import React from 'react'
import { TextField } from '@material-ui/core'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import messages from '../UsersList/UsersList.messages'
import { UsersListDropdownProps } from './UsersListDropdown.types'
import { SearchInputContainer, StyledPopover } from './UsersListDropdown.styles'

const UsersListDropdown = ({
  intl: { formatMessage },
  anchor,
  onCloseMenu,
  searchQuery,
  setSearchQuery,
  inputRef,
  renderUserList,
  noTransform,
}: UsersListDropdownProps & WrappedComponentProps) => (
  <StyledPopover
    anchorEl={anchor}
    open={!!anchor}
    onClose={onCloseMenu}
    $noTransform={noTransform}
    PaperProps={{
      style: { maxHeight: '400px' },
    }}>
    <SearchInputContainer>
      <TextField
        value={searchQuery}
        placeholder={formatMessage(messages.search)}
        onChange={({ target: { value: searchFieldValue } }) =>
          setSearchQuery(searchFieldValue)
        }
        inputProps={{ ref: inputRef }}
      />
    </SearchInputContainer>
    {renderUserList()}
  </StyledPopover>
)

export default injectIntl(UsersListDropdown)
